import React, {useState, useEffect, useRef} from "react";
import { axiosInstance } from "../../../client";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../../context/auth";
import { postUserSupplierAdherence } from "../../../client/userAdherence";

export function MicrosoftAuth() {
    const navigate = useNavigate();
    const hasFetched = useRef(false);
    const {login} = useAuth();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (!code) {
            navigate("/");
            return;
        }

        const handleMicrosoftLogin = async () => {
            try {
                const response = await axiosInstance.post("auth/microsoft-login", { code });
                const { token, userId } = response.data;

                if (token && userId) {
                    login(
                        userId,
                        token,
                        userId.supplierId,
                        userId.category_supplier,
                        userId.supplierCode
                    );

                    try {
                        await postUserSupplierAdherence(userId.id, 0);
                        await axiosInstance.put(`Supplier/GetSupplierData/${userId.supplierCode}`);
                    } catch (error) {
                        console.error('Error en operaciones posteriores:', error);
                    }

                    navigate("/inicio");
                } else {
                    throw new Error("Faltan token o userId en la respuesta");
                }
            } catch (error) {
                console.error("Error en la autenticación:", error);

                if (error.response?.status === 429) {
                    const errorMessage = error.response?.data?.message || 
                        "Has superado el número máximo de intentos. Intente nuevamente luego de un minuto.";

                    setError(errorMessage);
                    navigate("/", { 
                        state: { 
                            microsoftAuthError: errorMessage,
                            showMicrosoftModal: true,
                            isRateLimitError: true 
                        } 
                    });
                } else {
                    const errorMessage = error.response?.data?.error || 
                        "Su cuenta no está autorizada. Por favor, contacte al administrador.";

                    setError(errorMessage);
                    navigate("/", { 
                        state: { 
                            microsoftAuthError: errorMessage,
                            showMicrosoftModal: true 
                        } 
                    });
                }
            }
        };

        handleMicrosoftLogin();
        
    }, [navigate, login]);

    return <p>Procesando autenticación...</p>;
}